<template>
  <el-tooltip class="item" effect="dark" placement="top-start" :content="title">
    <font-awesome-icon v-if="icon" :icon="icon" />
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { StreamLabels, StreamLabel } from '@/api/types'

const ICONS: Record<number, string> = {
  1: 'venus-mars',
  2: 'mars-double',
  3: 'mercury',
  4: 'transgender',
  5: 'child'
}

export default defineComponent({
  name: 'StreamIcon',
  props: {
    streamId: {
      type: Number,
      default: 1
    }
  },
  setup(props, context) {
    const icon = computed(() => {
      return ICONS[props.streamId]
    })

    const title = computed(() => {
      return StreamLabels.find(
        (label: StreamLabel) => label.stream === props.streamId
      )?.label
    })

    return { icon, title }
  }
})
</script>
